<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <blue-title class="style">补充材料</blue-title>
      <SupplementInfo
        :count.sync="count"
        :allData="allData"
        @handleMediaId="handleMediaId"
        @additionPicsMediaId="additionPicsMediaId"
        @confirm="handleValiditySupplement"
      ></SupplementInfo>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info" @click="count++">保存草稿</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SupplementInfo from '../../components/supplementInfo/supplementInfo';
import { saveEditDraft, draftEcho, mediaId } from '../../../../api/module/merchants';

export default {
  components: {
    SupplementInfo,
  },
  props: {},
  data() {
    return {
      SupplementInfo: {
        legalPersonCommitment: '',
        legalPersonVideo: '',
        businessAdditionPics: '',
        businessAdditionMsg: '',
      },
      allData: {},
      count: 0, // 是否开始验证
      SupplementPass: false,
      legalPersonMedia: '',
      businessAdditionPicsMedia: '',
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    if (this.type == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    handleValiditySupplement({ flag, ruleForm }) {
      this.SupplementInfo = { ...ruleForm };
      this.SupplementPass = flag;
      this.handleSave();
    },
    handleSave() {
      const { SupplementPass } = this;
      if (SupplementPass) {
        console.log('成功');
        const obj = this.formatSubmitData();
        console.log('处理后的数据===', obj);
        this.saveEditDraft(obj);
      }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const { SupplementInfo, uuid, merchantId, legalPersonMedia, businessAdditionPicsMedia } = this;
      obj = {
        supplementaryMaterialsVO: {
          businessAdditionMsg: SupplementInfo.businessAdditionMsg,
          businessAdditionPics: SupplementInfo.businessAdditionPics,
          createTime: '',
          id: 0,
          legalPersonCommitment: SupplementInfo.legalPersonCommitment,
          legalPersonCommitmentMedia: legalPersonMedia,
          businessAdditionPicsMedia,
          legalPersonVideo: '',
          status: 0,
          updateTime: '',
          uuid: '',
        },
        uuid,
        merchantId,
        type: 'supplementary',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      // const result = await saveEditDraft({ ...obj });
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId,
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    handleMediaId(url, fileName) {
      this.mediaId(url, fileName);
    },
    additionPicsMediaId(url, fileName) {
      this.mediaId1(url, fileName);
    },
    async mediaId(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.legalPersonMedia = result.mediaId;
    },
    async mediaId1(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.businessAdditionPicsMedia = result.mediaId;
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.allData = result;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 100px;
  }
}
</style>
